import Modal from '../modal/modal';
import ZombieParrot from '../../images/zombieparrot.gif';
import DisplayHelper from '../../helpers/display_helper';
import Anchor from '../shared/anchor';
import ActionWithLoading from '../shared/action_with_loading';
import FetchHelper from '../../helpers/fetch_helper';
import Actions from '../../actions/actions';
import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import DobFormatInput from '../shared/date_format_input';
import moment from 'moment';
import ExpirationHelper from '../../helpers/expiration_helper';
import withDataLoaded from '../with_data_loaded';
import { stepDisbursementsLoader } from '../../actions/data_loaders';
import { TextField } from '@mui/material';

function ResurectCustomerModal({ hideFunction, setProcessing, processing }) {
  const [adjustedExpirationDate, setAdjustedExpirationDate] = useState(null);
  const [adjustedExpirationDateError, setAdjustedExpirationDateError] = useState(null);
  const customerDisbursements = useSelector((redux) => redux.customerDisbursementInfo);

  const customerId = useSelector(({ customer }) => customer?.id);
  const proposalId = useSelector(({ proposal }) => proposal?.id);
  const isExpired = useSelector(({ eligibility }) => eligibility?.creditCheck?.expired);

  const originalExpireDate = useSelector(({ eligibility }) => eligibility?.creditCheck?.originalExpireDate);

  let daysAfterOriginalExpiration = ExpirationHelper.daysAfterExpiration(originalExpireDate);
  // console.log('daysAfterOriginalExpiration', daysAfterOriginalExpiration);
  if (originalExpireDate && Math.abs(daysAfterOriginalExpiration) > ExpirationHelper.DAYS_TOO_MANY) {
    return (
      <Modal
        container={document.body}
        // customer={customer}
        title={<h5>{`Super Admin, Sorry...`}</h5>}
      >
        <div className="confirmation-section-wrapper" id={'contact-support-to-cancel'}>
          <div className="confirmation-section-message">
            <p>
              Original Expiration Date is: {DisplayHelper.formatDateNoTime(originalExpireDate)}
              <br />
              This customer cannot be reinstated because it expired more than {ExpirationHelper.DAYS_TOO_MANY} days ago.
            </p>
          </div>
          <div className="confirmation-section-controls">
            <ActionWithLoading onClick={() => hideFunction(false)} classNames="confirm-cancel action-info">
              Ok.
            </ActionWithLoading>
          </div>
        </div>
      </Modal>
    );
  }
  // let today = moment(new Date()).startOf('day');
  // let adjustedStart = moment(adjustedExpirationDate, 'YYYY-MM-DD').startOf('day');
  // console.log(
  //   "moment().diff(adjustedExpirationDate, 'days')",
  //   adjustedExpirationDate,
  //   today,
  //   adjustedStart,
  //   today.diff(adjustedStart, 'days')
  // );
  // );
  return (
    <Modal
      container={document.body}
      // customer={customer}
      title={
        <>
          {'Super Admin, are you sure you want to reinstate this customer '}
          <img src={ZombieParrot} height={32} width={32} alt={'zombie'} />
          {'?'}
        </>
      }
    >
      {' '}
      <div className="confirmation-section-wrapper" id={'cpf-reinstate-customer-modal'}>
        <div className="confirmation-section-message">
          <p>
            <span>Are you sure you want to reinstate this customer?</span>
          </p>
          <br />
          {/*<p>*/}
          {customerDisbursements && customerDisbursements.filter(({ clawbackDate }) => clawbackDate).length > 0 && (
            <>
              <h1 style={{ color: 'red', fontSize: 'xxx-large' }} id={'qa-reinstate-customer-stop'}>
                🛑 STOP! 🛑
              </h1>
              {customerDisbursements
                .filter(({ clawbackDate }) => clawbackDate)
                .map(({ clawbackDate, loanNumber }, i) => {
                  return (
                    <div key={i} style={{ width: '100%' }}>
                      <h1 style={{ color: 'red', fontSize: 'xxx-large' }} id={'qa-reinstate-customer-clawback-info'}>
                        A clawback for loan {loanNumber} occurred on{' '}
                        {DisplayHelper.formatTimelessDateNoTime(clawbackDate)}
                      </h1>
                    </div>
                  );
                })}
            </>
          )}
          {isExpired && (
            <div>
              <TextField
                className="text-field"
                name={'resurrection-adjusted-expiration-date'}
                required={isExpired}
                fullWidth={true}
                size={'medium'}
                margin={'normal'}
                variant="outlined"
                label={'Adjusted Expiration Date (MM/DD/YYYY)'}
                id={'resurrection-adjusted-expiration-date'}
                onBlur={(evt) => {
                  if (evt.target.value?.length < 10) {
                    setAdjustedExpirationDateError('Need a Date');
                  } else {
                    setAdjustedExpirationDateError(null);
                  }
                }}
                onChange={(evt) => {
                  setAdjustedExpirationDate(moment(evt.target.value, 'MM/DD/YYYY').format('YYYY-MM-DD'));
                  setAdjustedExpirationDateError(null);
                }}
                InputLabelProps={{ required: isExpired }}
                InputProps={{
                  inputComponent: DobFormatInput,
                }}
                error={adjustedExpirationDateError}
                helperText={adjustedExpirationDateError ? adjustedExpirationDateError : ''}
              />
            </div>
          )}
        </div>
        <div className="confirmation-section-controls" style={{ display: 'flex' }}>
          <Anchor
            className="do-not-reinstate"
            id={'do-not-reinstate-customer'}
            onClick={() => {
              hideFunction(false);
            }}
          >
            Go Back
          </Anchor>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ActionWithLoading
            disabled={isExpired && ExpirationHelper.isFarPastExpiration(adjustedExpirationDate, originalExpireDate)}
            onClick={async () => {
              setProcessing(true);
              try {
                if (
                  adjustedExpirationDate &&
                  originalExpireDate &&
                  ExpirationHelper.isFarPastExpiration(adjustedExpirationDate, originalExpireDate)
                ) {
                  setProcessing(false);
                  return;
                }

                await FetchHelper.fetchJson(`customers/${customerId}/financing-requests/restore`, {
                  method: 'post',
                  body: { adjustedExpirationDate },
                  version: '/v3',
                });
                Actions.setMessages([`Customer Reinstated`]);
                let newProposal = await Actions.fetchProposal(proposalId);

                Actions.goToProposalPage({
                  subPage: 'step-documents',
                  financingRequestId: newProposal.financingRequestId,
                });
                Actions.refreshFinancingMethods();
                Actions.fetchFinancingRequest({ customerId });
                Actions.fetchCustomer(customerId);
                if (adjustedExpirationDate) {
                  Actions.fetchEligibility({ customerId });
                }
                hideFunction(false);
              } catch (e) {
                setAdjustedExpirationDateError(e.messages);
                Actions.setErrorMessages(e.messages);
              } finally {
                setProcessing(false);
              }
            }}
            classNames="confirm-cancel action-warning"
            id={'confirm-cpf-reinstate-customer'}
            processing={processing}
          >
            Yes, Reinstate
          </ActionWithLoading>
        </div>
      </div>
    </Modal>
  );
}

export default withDataLoaded({
  WithData: ResurectCustomerModal,
  data: [stepDisbursementsLoader],
});
